import { Department } from '../../types/department.enum';
import { Segment } from '../../types/segment.enum';

export class UploadedFileDetail {
    name!: string;
    extension!: string;
    department!: Department;
    segment!: Segment;
}
